import { IMachine } from '../machines/machines'
import { machines } from '../machines/machines-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, ITask } from './jobs'
import { jobs } from './jobs-sidecar'
import { createTask_goToMachine } from './taskGoToMachine'

export function createTask_putOnSuit(i: number, j: number): ITask {
  return jobs._createTask(i, j, 'put-on-suit', {})
}

export function runTask_putOnSuit(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, 'put-on-suit')
  let m = jobLogger.assertReserved(job)

  if (jobLogger.runSubtasks(job, task)) {
    return
  }

  if (m.isInSuit) {
    return jobLogger.succeedTask(job, task)
  }

  let f = (c: IMachine) => c.data.type === 'suits'
  let mc = machines.findAtSpot(m.i, m.j, f)
  if (mc) {
    // Here!
    mc.hasSuit = false
    monsters.setInSuit(m, true)
    return jobLogger.succeedTask(job, task)
  }

  task.subtasks.push(createTask_goToMachine(m.i, m.j, f))

  // if (task.type !== 'put-on-suit') {
  //   throw new Error('wrong task type')
  // }
  // let m = job.reservedBy
  // if (!m) {
  //   throw new Error('job not reserved by anyone')
  // }

  // // Are we finding a path?
  // if (job.findPathId) {
  //   return // Wait for this to complete
  // }

  // // Are we moving?
  // if (m.path.length > 0) {
  //   return // Wait for this to complete
  // }
  // let f = (c: IMachine) => c.data.type === 'suits'

  // if (machines.findAtSpot(m.i, m.j, f)) {
  //   // Here!
  //   return jobLogger.succeedTask(job, task)
  // }

  // let mc = machines.findClosestTo(m.i, m.j, f)
  // if (!mc) {
  //   return jobLogger.failTask(job, task, 'lost machine')
  // }

  // // Find path to delivery spot!
  // job.findPathId = pathFinder.findPath(
  //   m.i,
  //   m.j,
  //   mc.i,
  //   mc.j,
  //   m.isInsideShip,
  //   (path) => {
  //     job.findPathId = 0
  //     if (!task) {
  //       throw new Error('lost our task!')
  //     }

  //     if (!path || path.length === 0) {
  //       return jobLogger.failTask(job, task, 'no path')
  //     } else {
  //       if (m) {
  //         monsters.setPath(m, path)
  //       }
  //     }
  //   },
  // )
}
